import { render, staticRenderFns } from "./UserD_TransactionSetting.vue?vue&type=template&id=42729ab5"
import script from "./UserD_TransactionSetting.vue?vue&type=script&lang=js"
export * from "./UserD_TransactionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports